var Plugin = require("common/Plugin");
var SettingsController = require("./SettingsController");
var GeneralAppConfigSettingsDelegate = require("./GeneralAppConfigSettingsDelegate");
var TOTPSettingsDelegate = require("./totp/TOTPSettingsDelegate");
var TOTPEnrollmentView = require("./totp/TOTPEnrollmentView");
var TOTPBackupCodesView = require("./totp/TOTPBackupCodesView");
var TOTPMenuView = require("./totp/TOTPMenuView");
var TOTPTokenDialog = require("./totp/TOTPTokenDialog");
var TOTPAuthDialog = require("./totp/TOTPAuthenticationDialog");
var LogonRequestFailureHandler = require("../logon/LogonRequestFailureHandler");

function SettingsPlugin() {
    var self = this;

    this.start = function(controllerDelegates) {
        controllerDelegates = controllerDelegates || [];

        var controller = new SettingsController();
        CudaLaunch.controllers.SettingsController = controller;

        var totpDelegate = new TOTPSettingsDelegate(new TOTPMenuView(),
            new TOTPEnrollmentView(), new TOTPBackupCodesView(), new TOTPTokenDialog(),
            new TOTPAuthDialog(), new LogonRequestFailureHandler(true));

        controllerDelegates.push(new GeneralAppConfigSettingsDelegate());
        controllerDelegates.push(totpDelegate);
        controllerDelegates.forEach(function(delegate) {
            controller.addDelegate(delegate);
        });

        self.registerController(controller);

        var onClick = function() {
            controller.showListView();
        };

        // Add to the appropriate menus
        ["addOptionsMenuEntry", "addPreAuthMenuEntry"].forEach(function(fn) {
            self[fn]($.t("common::settings.title"),
                onClick,
                10);
        });
    };
}

SettingsPlugin.prototype = Plugin;
SettingsPlugin.prototype.constructor = SettingsPlugin;

module.exports = SettingsPlugin;


//////////////////
// WEBPACK FOOTER
// ./settings/SettingsPlugin.js
// module id = 83
// module chunks = 0 3